module.exports = __WEBPACK_EXTERNAL_MODULE_4__;


//////////////////
// WEBPACK FOOTER
// external {"root":"angular","amd":"angular","commonjs2":"angular","commonjs":"angular"}
// module id = 4
// module chunks = 0 1